"use client";

import React from "react";
import { cn } from "utils/utils";
import { TradeItem } from "modules/tradeLists/model/tradeList";
import { getTradeRelationship } from "modules/tradeLists/utils/tradeRelationshipUtils";
import { useAuth } from "@clerk/nextjs";
import { useCardGridItemContext } from "./CardGridItemContext";

export function CardGridItemRelationshipBadge() {
  const { item: baseItem } = useCardGridItemContext();
  const { userId, isLoaded } = useAuth();
  const item = baseItem as TradeItem;

  if (!isLoaded || !userId) {
    return (
      <div className="bg-base-200 flex items-center justify-center rounded-lg p-1.5 text-xs">
        <span className="loading loading-spinner loading-xs" />
        <span className="text-base-content/60 ml-1">Loading</span>
      </div>
    );
  }

  const relationship = getTradeRelationship(item, userId);
  const RelationshipIcon = relationship.icon;

  return (
    <div
      className={cn(
        "-mb-0.5 mt-0.5 flex items-center gap-1 rounded-lg p-1.5 text-xs md:text-sm",
        relationship.bgColor
      )}
    >
      <RelationshipIcon size={14} className={cn(relationship.color)} />
      <span className={cn(relationship.color)}>{relationship.text}</span>
    </div>
  );
}
